import {AfterViewInit, Component, ContentChildren, ElementRef, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {UIRadioComponent} from './ui-radio/ui-radio.component';

export class UIRadioSelectEvent {
    target: UIRadioComponent;
    index: number;
    value: any;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ui-radio-group',
    templateUrl: 'ui-radio-group.component.html'
})
export class UIRadioGroupComponent implements AfterViewInit{
    private radios: UIRadioComponent[] = [];
    private selectedRadio: UIRadioComponent;
    // tslint:disable-next-line:variable-name
    private _loading = false;
    @Output() select = new EventEmitter<UIRadioSelectEvent>();
    @ContentChildren(UIRadioComponent) uiRadioQueryList: QueryList<UIRadioComponent>;
    @Input() set loading(value: boolean) {
        this._loading = value;
        if (this.host) {
            value
                ? this.host.nativeElement.classList.add('≈pointer-events-none', '≈select-none')
                : this.host.nativeElement.classList.remove('≈pointer-events-none', '≈select-none');
            const radios = Array.from(this.host.nativeElement.children).filter(child => child.tagName === 'UI-RADIO');
            for (const radio of radios) {
                value ? radio.classList.add('≈opacity-25') : radio.classList.remove('≈opacity-75');
            }
        }
    }
    get loading() {
        return this._loading;
    }

    constructor(
        private host: ElementRef<HTMLElement>
    ) {
    }

    ngAfterViewInit() {
        this.getRadios();
        this.initializeRadioGroup();
        this.uiRadioQueryList.changes.subscribe(() => {
            this.getRadios();
            this.initializeRadioGroup();
        });
    }

    initializeRadioGroup() {
        this.applyStyling();
        this.selectDefaultRadio();
        this.setRadioOnselect();
    }

    applyStyling() {
        this.host.nativeElement.classList.add('≈relative');
    }

    getRadios() {
        this.radios = this.uiRadioQueryList['_results'] as UIRadioComponent[];
    }

    selectDefaultRadio() {
        this.selectedRadio = this.radios.find(radio => radio.selected);
        if (!this.selectedRadio) { return; }
        this.selectedRadio.selected = true;
        this.select.emit({
            target: this.selectedRadio,
            index: this.radios.findIndex(radio => radio === this.selectedRadio),
            value: this.selectedRadio.value
        });
    }

    setRadioOnselect() {
        this.getRadios();
        for (const radio of this.radios) {
            radio.select = () => {
                this.radios.forEach(r => r.selected = false);
                radio.selected = true;
                this.selectedRadio = radio;
                this.select.emit({
                    target: radio,
                    index: this.radios.findIndex(r => r === radio),
                    value: radio.value
                });
            };
        }
    }
}
